import * as types from './mutation-types'

const matutaions = {
    [types.AUTHOR_CODE](state, authorCode) {
        state.authorCode = authorCode;
        window.localStorage.setItem('authorCode', authorCode);
    },
    [types.USERINFO](state, userInfo) {
        state.userInfo = userInfo;
        window.localStorage.setItem('userInfo', userInfo);
    },
    [types.CANCALACTIVENAME](state, cancalActiveName) {
        state.cancalActiveName = cancalActiveName;
    },
    [types.TASKSINFODATA](state, tasksInfoData) {
        state.tasksInfoData = tasksInfoData;
    },
    [types.TASKSACCEPTANCESSTATISTICS](state, tasksAcceptancesStatistics) {
        state.tasksAcceptancesStatistics = tasksAcceptancesStatistics;
    },
    [types.TASKSACCEPTANCESLIST](state, tasksAcceptancesList, tasksAcceptancesData) {
        state.tasksAcceptancesList = tasksAcceptancesList;
    },
    [types.TASKSACCEPTANCESDATA](state,tasksAcceptancesData) {
        state.tasksAcceptancesData = tasksAcceptancesData;
    }
}

export default matutaions
